import React from "react";

const NotFound = ({
    parent,
}: {
    parent: "index" | "schedule" | "myschedule" | "admin";
}): React.JSX.Element => {
    let errorContent: React.ReactNode;

    switch (parent) {
        case "schedule":
            errorContent = "Scheduling Page Not Found";
            break;
        case "myschedule":
            errorContent = "My Schedule Page Not Found";
            break;
        case "admin":
            errorContent = "Admin Page Not Found";
            break;
        default:
            errorContent = "Page Not Found";
            break;
    }

    return <h2>{errorContent}</h2>;
};

export default NotFound;
